<template>
	<div class="movie-hall page">
		<van-nav-bar class="nav-bar" :title="$t('page.ordlan.PopularMembers')" />

		<div class="">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div class="tu_list">
					<van-list v-model="loading" :finished="finished" :immediate-check="false"
						:finished-text="$t('page.video.noMore')" @load="onLoad">
						<div>
							<div class="item" v-for="(v,key) in datalist" :key="key" @click="toPlayVideo(v.id)">
								<div class="left">
									<van-image class="cover_img" width="120px" height="120px"   radius="10"  :src="v.img_url">
										<template v-slot:loading>
											<van-loading type="circular" />
										</template>
									</van-image>
									<div class="item_id">{{ v.username }}</div>
								</div>
								<div class="right">
									<div class="badge-container">
										<span class="badge-item">
											<span class="badge-icon">
												<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy9JREFUWEfdlk1IVFEUx//nOfaxKVpEgcsWSh/gwr5oUUb0tYjAdDFvtBZR2dyRgqLSeYPNGzWCEHxvJFplzhtBJXCVFfS1CCsjCGzRxz4K3LUp5514b7RGe3fem7EQust3zrn/3zn3nPsuYYkXLbE+lh5gUBd7yq1Cs2Y+WRhb6n7kBCjAPQArSgD5ZAMnZQAK8DjIXjZQ7x5Bpju2kXI8DGCTXyAzn18WUqymduOrzHe4O7Z2xuZGZqQ9fD7YNrLLubKvqbN3el4PWLr4DGBdMQiH2itzrxhLFx8BbCi0MehARDMezH2bD9B1tha28qYYAIFvhLX0Bb9KOXZLF9MA1sz5MtAT0cz2wtg/piCTjJ4jol6pAOO9mjCr/QCGktHtNtHE70xpPKwZhxbGeY6hpYvnAHbKRHLMO1oS6RfFILJ67CKDr//yYaVOTfS9DgaQiqlgzhQR6FQ182pxgOgIg465PoRbatw87eUvvYgsXdwHsN8ziDAZjptbZQDZblFj5/CWgErXR5J9nk2yhnRxxAbGZHYiPhGOpwe87BldpAjo8Mu+KIBjzKbEKDMaJBDPVM3cvdA2fO3S6pkf36YYqPLL3hfA6mqrh20/kp41oUmNmyOFdisZEyA2gmTvC+A4ZHRxm4DjXhAMHo9o6XmjZenCuUdqg2QfCGAoJepsxktpvyg4qHaYTsM6R9bAjNGg2QcCcJyspDBAEJKjuKtqptsnhZPDbG+LJPpfSY9v1hDoPZDtFDVcAefiWeW1oU32LgUUAtPTfPY0psaNo37igSvgllcX3Qxc8e4FDBA4BJDq2G2icHPcGPqrAAOpM1UVHJokYL3PxlPhuLGFiPivArgTkRQ9RLjss3FC1Uw9iHhJR+A4D+qt1QoqnDFbKRH4DiibVa3vwz8ByHd6tB+gVonAHVUzPe8MGVCgKSgMtlKxbWD2/BWzgsORDtN5XwZeJQPkqxDLAOx2/Nwi8POwlt4VWHnWsVyAfQA/nA+AtrBm5v8BJayyAPJVEM4runFWayqXm9nb0nnzSwnarmvZAC5EMnqKocwghIlIu/GuVPFFA5QjuDBmURX4LwB+Ajq/G9S6JXoiAAAAAElFTkSuQmCC"
													alt="VIP" class="vip_image">
											</span> 
												{{ $t('page.ordlan.IdentityVerification') }}
											</span>
										<span class="badge-item">
											<span class="badge-icon">
												<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy9JREFUWEfdlk1IVFEUx//nOfaxKVpEgcsWSh/gwr5oUUb0tYjAdDFvtBZR2dyRgqLSeYPNGzWCEHxvJFplzhtBJXCVFfS1CCsjCGzRxz4K3LUp5514b7RGe3fem7EQust3zrn/3zn3nPsuYYkXLbE+lh5gUBd7yq1Cs2Y+WRhb6n7kBCjAPQArSgD5ZAMnZQAK8DjIXjZQ7x5Bpju2kXI8DGCTXyAzn18WUqymduOrzHe4O7Z2xuZGZqQ9fD7YNrLLubKvqbN3el4PWLr4DGBdMQiH2itzrxhLFx8BbCi0MehARDMezH2bD9B1tha28qYYAIFvhLX0Bb9KOXZLF9MA1sz5MtAT0cz2wtg/piCTjJ4jol6pAOO9mjCr/QCGktHtNtHE70xpPKwZhxbGeY6hpYvnAHbKRHLMO1oS6RfFILJ67CKDr//yYaVOTfS9DgaQiqlgzhQR6FQ182pxgOgIg465PoRbatw87eUvvYgsXdwHsN8ziDAZjptbZQDZblFj5/CWgErXR5J9nk2yhnRxxAbGZHYiPhGOpwe87BldpAjo8Mu+KIBjzKbEKDMaJBDPVM3cvdA2fO3S6pkf36YYqPLL3hfA6mqrh20/kp41oUmNmyOFdisZEyA2gmTvC+A4ZHRxm4DjXhAMHo9o6XmjZenCuUdqg2QfCGAoJepsxktpvyg4qHaYTsM6R9bAjNGg2QcCcJyspDBAEJKjuKtqptsnhZPDbG+LJPpfSY9v1hDoPZDtFDVcAefiWeW1oU32LgUUAtPTfPY0psaNo37igSvgllcX3Qxc8e4FDBA4BJDq2G2icHPcGPqrAAOpM1UVHJokYL3PxlPhuLGFiPivArgTkRQ9RLjss3FC1Uw9iHhJR+A4D+qt1QoqnDFbKRH4DiibVa3vwz8ByHd6tB+gVonAHVUzPe8MGVCgKSgMtlKxbWD2/BWzgsORDtN5XwZeJQPkqxDLAOx2/Nwi8POwlt4VWHnWsVyAfQA/nA+AtrBm5v8BJayyAPJVEM4runFWayqXm9nb0nnzSwnarmvZAC5EMnqKocwghIlIu/GuVPFFA5QjuDBmURX4LwB+Ajq/G9S6JXoiAAAAAElFTkSuQmCC"
													alt="VIP" class="vip_image">
											</span> 
											{{ $t('page.ordlan.PersonalVideoVerification') }}
											</span>
									</div>
									<div class="info-container">
										<p class="star-rating">
											{{ $t('page.ordlan.Rating') }}:
											<span class="star" v-for="(v,key) in v.start" ></span>
										</p>
										<div class="user-details">
											{{ v.xuanfei_name }}
										</div>
									</div>
									<div class="apply-btn">{{ $t('page.ordlan.AppointmentRequest') }} </div>
								</div>
							</div>

						</div>
					</van-list>
				</div>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				active: 0,
				isLoading: false,
				count: 0,
				loading: false,
				finished: false,
				refreshing: false,
				videolitem: [],
				datalist: [],
				number: 0,
				page: 0,
				videoSwiperOption: {
					slidesPerView: 'auto',
					spaceBetween: 0,
					slidesPerGroup: 1,
				}
			};
		},
		methods: {
			getVideoClass() {
				this.$http({
					method: 'get',
					url: 'video_class'
				}).then(res => {
					this.videolitem = res.data;
				})
			},
			toPlayVideo(id) {
				// this.$router.push({ path: '/profile?id=' + id + '&name=' + this.vod_name + '&adsid=' + id });
				// return false;
				if (!localStorage.getItem('token')) {
					this.$router.push({
						path: '/Login'
					})
				} else {
					this.$router.push({
						path: '/profile?id=' + id
					})
				}

			},
			itemChange() {
				this.active = this.$refs.swiper.swiper.activeIndex
				this.OnChange()
			},
			getxuanfeilistv2() {
				this.$http({
					method: 'get',
					data: {
						id: this.active,
						page: this.page
					},
					url: 'xuanfeilistv2'
				}).then(res => {
					this.page = this.page + 1;
					this.datalist = this.datalist.concat(res.data.data);
					this.count = res.data.count;
					this.page++;

				})
			},
			onLoad() {
				this.getxuanfeilistv2();
				let timer = setTimeout(() => {
					if (this.refreshing) {
						this.datalist = [];
						this.refreshing = false;
					}
					this.loading = false;
					if (this.datalist.length === this.count) {
						this.finished = true;
					}
					this.finished && clearTimeout(timer); //清除计时器
				}, 1500);
			},
			OnChange() {
				this.datalist = [];
				this.number = 0;
				this.page = 0;
				this.count = 0;
				this.getxuanfeilistv2(); //获取视频列表
			},
			onRefresh() {
				setTimeout(() => {
					this.finished = false;
					this.loading = true;
					this.onLoad();
					this.isLoading = false;
					Toast(this.$t('page.video.refreshSuccess'));
				}, 500);
			},
		},
		created() {
			this.getVideoClass(); //获取视频类目
			this.OnChange()
		}
	};
</script>

<style lang='less' scoped>
	.page {
		position: relative;
		/* height: 100vh; */
		top: 0;
		left: 0;
		right: 0;
		background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
	}

	.nav-bar {
		background: linear-gradient(135deg, #3498db, #8e44ad);
		height: 100px;
	}

	.van-nav-bar {
		line-height: 50px;
	}

	::v-deep .van-nav-bar__title {
		max-width: 60%;
		margin: 0 auto;
		color: #ffffff;
		font-size: 35px;
	}

	::v-deep .van-nav-bar__content {
		height: 100px;
	}






	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #000;
		font-size: 35px;
	}

	.tu_list {
		/* height: 85vh; */
	}

	.tu_list .item {
		margin: 3.73333vw 2.66667vw 2.13333vw;
		padding: 3.2vw;
		border-radius: 2.66667vw;
		background: linear-gradient(135deg, #fff, #f8f9fa);
		border: 1px solid #fff;
		box-shadow: 0 .53333vw 2.66667vw #00000014;
		display: flex;
		justify-content: space-between;
		position: relative;
		overflow: hidden
	}

	.tu_list .item .left {
		width: 29.33333vw;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		border-radius: 1.33333vw;
		overflow: hidden
	}

	.tu_list .item .left .avatar {
		width: 100%;
		object-fit: cover;
		border-radius: 1.06667vw
	}

	.tu_list .item .left .item_id {
		color: #34196a;
		margin-top: 1.6vw;
		text-align: center;
		font-size: 3.73333vw
	}

	.tu_list .item .right {
		flex: 1;
		padding-left: 2.66667vw;
		margin-left: 3.2vw;
		display: flex;
		flex-direction: column;
		justify-content: space-between
	}

	.tu_list .item .right .badge-container {
		display: flex;
		margin-bottom: 1.6vw;
		gap: 2.13333vw
	}

	.tu_list .item .right .badge-container .badge-item {
		font-size: 2.93333vw;
		padding: 1.06667vw 2.66667vw;
		display: flex;
		align-items: center;
		color: #4a5568;
		background: linear-gradient(135deg, #667eea1a, #764ba21a);
		border-radius: 2.66667vw;
		border: 1px solid rgba(102, 126, 234, .2);
		font-weight: 500;
		box-shadow: 0 1px 1.06667vw #667eea1a;
		transition: all .3s ease;
		text-align: center
	}

	.tu_list .item .right .badge-container .badge-item .badge-icon {
		margin-right: .8vw;
		font-size: 3.2vw;
		color: #fff
	}

	.tu_list .item .right .badge-container .badge-item .vip_image {
		width: 1.86667vw;
		height: 1.86667vw;
		filter: drop-shadow(0 1px .267vw rgba(0, 0, 0, .1));
		object-fit: contain
	}

	.tu_list .item .right .info-container {
		background: #f8fafccc;
		padding: 1.6vw;
		border-radius: 1.6vw;
		margin-bottom: 1.6vw;
		border: 1px solid rgba(226, 232, 240, .6);
		-webkit-backdrop-filter: blur(1.33333vw);
		backdrop-filter: blur(1.33333vw)
	}

	.tu_list .item .right .info-container .star-rating {
		color: #e53e3e;
		font-weight: 700;
		margin-bottom: .8vw;
		font-size: 2.66667vw;
		display: flex;
		align-items: center
	}

	.tu_list .item .right .info-container .star {
		display: inline-block;
		width: 1.86667vw;
		height: 1.86667vw;
		background: url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20fill='%23f6ad55'%20d='M12%2017.27L18.18%2021l-1.64-7.03L22%209.24l-7.19-.61L12%202%209.19%208.63%202%209.24l5.46%204.73L5.82%2021z'/%3e%3c/svg%3e") no-repeat;
		margin: 0 1px;
		filter: drop-shadow(0 1px 1px rgba(0, 0, 0, .2))
	}

	.tu_list .item .right .info-container .user-details {
		color: #718096;
		font-size: 2.93333vw;
		line-height: 1.5;
		font-weight: 500;
		background: linear-gradient(135deg, #4a5568, #718096);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent
	}

	.tu_list .item .right .apply-btn {
		padding: 2.66667vw 5.33333vw;
		font-size: 3.46667vw;
		background: linear-gradient(135deg, #3498db, #8e44ad);
		color: #fff;
		border-radius: 3.2vw;
		text-align: center;
		font-weight: 700;
		cursor: pointer;
		transition: all .3s ease;
		box-shadow: 0 .53333vw 2vw #667eea4d;
		position: relative;
		overflow: hidden;
		letter-spacing: .5px
	}
</style>